var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wrapper-filters',{attrs:{"title":"","sendFilterRequestAfterSelect":true,"showResetFilterButton":false,"showCollapseFilter":false,"filtersUrl":"/cabinet/partner/monetizestatistic/getDynamicList","filtersUrlMethod":"get","setEnabledFilters":{
        services: {
          enable: true,
          multiple: true,
          getDataLink: '/services/getList',
          placeholder: this.getLocalization('Services'),
          specifiedKeyForId: 'activate_org_code',
          column: 2,
        },
        countries: {
          enable: true,
          multiple: true,
          getDataLink: '/countries/getList',
          placeholder: this.getLocalization('Countries'),
          specifiedKeyForId: 'activate_org_code',
          column: 3,
        },
        dateSelector: {
          enable: true,
          placeholder: this.getLocalization('Period'),
          noGroupSelect: true,
          closeOnSelect: true,
          startWithRequest: true,
          selectedKey: 'dateSelector',
          data: [
              {
                id: 3,
                title: this.getLocalization('Last day')
              },
              {
                id: 4,
                title: this.getLocalization('Last week')
              },
              {
                id: 5,
                title: this.getLocalization('Last month')
              },
          ],
          column: 1,
        },
      }},on:{"set-filtered-list":_vm.setFilteredList}}),_vm._v(" "),_c('div',{staticClass:"wrapperCanvas mt-5"},[(_vm.loaded)?_c('LineChart',{attrs:{"chart-data":_vm.chartData}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }